module.exports = __webpack_public_path__ + "img/facebook.d55aa4cd.svg";